// loadComponent comunica con la libreria npm che abbiamo installato, qui stiamo importando McElement che in sostanza estende HTMLElement (lo trovi nella sezione test)
// tutti i componenti che ti servono vanno chiamati così, con /components/nome-componente.js se sono su npm, li trovi tutti nella tab Componenti in sezione test
await loadComponent('./components/mc-element.js', false);

// queste sono le uniche librerie che hanno "res" invece che "components", le ho messe qua solo per farti vedere come si importano
await loadComponent('./res/mc-utils.js', false); // la trovi documentata sulla tab McUtils nella sezione test
await loadComponent('./res/mc-events.js', false); // la trovi documentata sulla tab Eventi nella sezione test
await loadComponent('./res/mc-shopify.js', false); // la trovi documentata sulla tab McShopify nella sezione test

class CollectionGrid extends McElement {

  connectedCallback() {
    window.addEventListener('collection:load', this.onCollectionLoad.bind(this));
    window.addEventListener('collection:filters', this.onFilterChange.bind(this));
  }

  onCollectionLoad(event) {
    const dom = McUtils.getDocument(event.detail.html);
    const products = dom.querySelectorAll('[data-collection-product]');
    products.forEach(product => {
      this.appendChild(product);
    });
  }

  async onFilterChange(event) {
    try {
      console.log('CollectionGrid: onFilterChange triggered');
      console.log('Event URL:', event.detail.url);
      console.log('Response available:', !!event.detail.response);
      
      // Prima di tutto, nascondi qualsiasi mc-loader esistente nella pagina
      document.querySelectorAll('mc-loader').forEach(loader => {
        loader.classList.add('d-none');
        if (loader.deactivate) {
          loader.deactivate();
        }
      });
      
      // Parse della risposta HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(event.detail.response, 'text/html');
      
      // Cerca diversi selettori possibili
      let newGrid = doc.querySelector('collection-grid#collection-grid');
      if (!newGrid) {
        newGrid = doc.querySelector('#collection-grid');
      }
      if (!newGrid) {
        newGrid = doc.querySelector('collection-grid');
      }
      
      console.log('Found grid:', !!newGrid);
      
      if (newGrid) {
        // Log del contenuto
        const productCount = newGrid.querySelectorAll('[data-collection-product]').length;
        console.log('Products in new grid:', productCount);
        
        // Se non ci sono prodotti con data-collection-product, cerca altri elementi
        if (productCount === 0) {
          const colCount = newGrid.querySelectorAll('.col').length;
          console.log('Cols in new grid:', colCount);
          console.log('First 200 chars of innerHTML:', newGrid.innerHTML.substring(0, 200));
        }
        
        // Usa direttamente innerHTML
        this.innerHTML = newGrid.innerHTML;
        
        // Dopo aver aggiornato, assicurati che eventuali mc-loader all'interno siano nascosti
        this.querySelectorAll('mc-loader').forEach(loader => {
          loader.classList.add('d-none');
          if (loader.deactivate) {
            loader.deactivate();
          }
        });
        
        // Verifica finale
        console.log('Final product count in DOM:', this.querySelectorAll('[data-collection-product]').length);
        
        // Trigger evento per altri componenti
        window.dispatchEvent(new CustomEvent('collection:updated'));
      } else {
        console.error('Collection grid not found in response');
        console.log('Available elements in doc:', doc.querySelectorAll('*').length);
        // Mostra messaggio solo se non ci sono già prodotti
        if (this.querySelectorAll('[data-collection-product]').length === 0) {
          this.innerHTML = '<div class="col-12 text-center py-5">Nessun prodotto trovato</div>';
        }
      }
    } catch (error) {
      console.error('Error updating collection grid:', error);
      console.error('Error stack:', error.stack);
    }
  }
}

if (!customElements.get('collection-grid')) {
  customElements.define('collection-grid', CollectionGrid);
}

window.CollectionGrid = CollectionGrid;